import { useLocation } from "react-router-dom";
import { useState } from "react";

const PackagesPage = () => {
  const location = useLocation();
  const resort = location.state?.resort;

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });

  if (!resort) return <div>No Packages Found</div>;

  // ✅ Handle Form Submit Properly
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = new FormData();
    form.append("access_key", "ac2e9cee-6cba-4036-ba57-56c081ef5ea8");
    form.append("subject", "New Wedding Package Booking");
    form.append("Resort Name", resort.name);
    form.append("Package Name", selectedPackage.title);
    form.append("User Name", formData.name);
    form.append("Phone", formData.phone);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: form,
      });

      const data = await response.json();

      if (data.success) {
        setIsSubmitted(true);
        setSelectedPackage(null);
        setFormData({ name: "", phone: "" });
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  return (
    <section className="bg-gray-50 min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="md:text-3xl text-xl font-semibold font-serif mb-8">
          {resort.name} – Wedding Packages
        </h1>

        {/* SUCCESS MESSAGE */}
        {isSubmitted && (
          <div className="mb-6 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg flex items-center gap-2 w-fit">
            <span className="text-green-600 font-bold text-lg">✔</span>
            <span>You will get notified shortly</span>
          </div>
        )}

        <div className="space-y-6">
          {resort.packages?.map((pkg, index) => (
            <div
              key={index}
              className="bg-white border rounded-xl shadow-sm overflow-hidden"
            >
              <div className="flex flex-col md:flex-row">
                {/* LEFT DETAILS */}
                <div className="md:w-3/4 p-6">
                  <h2 className="text-xl font-serif font-semibold mb-3">
                    {pkg.title}
                  </h2>

                  <ul className="text-sm text-gray-700 font-serif space-y-2">
                    {pkg.description?.split(",").map((point, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-green-600 font-bold mt-0.5">
                          ✔
                        </span>
                        <span className="leading-relaxed">{point.trim()}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* RIGHT PRICE SECTION */}
                <div className="md:w-1/4 bg-gray-50 p-6 flex flex-col justify-between border-t md:border-t-0 md:border-l">
                  <div>
                    <p className="text-sm font-serif text-gray-500">Starting From</p>
                    <h3 className="text-2xl font-bold font-montserrat text-rose-600">
                      ₹ {pkg.price}
                    </h3>
                    <p className="text-xs font-serif text-gray-400">per event package</p>
                  </div>

                  <button
                    disabled={isSubmitted}
                    onClick={() => setSelectedPackage(pkg)}
                    className={`mt-6 py-2 rounded-lg font-medium font-montserrat transition ${
                      isSubmitted
                        ? "bg-gray-300 cursor-not-allowed text-gray-600"
                        : "bg-[#b76d68] hover:bg-rose-600 text-white"
                    }`}
                  >
                    {isSubmitted ? "Booked" : "Select Package"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* POPUP FORM */}
        {selectedPackage && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-lg relative">
              <h2 className="text-xl font-semibold mb-4">
                Book {selectedPackage.title}
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-sm font-medium">Full Name</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      })
                    }
                    className="w-full border p-2 rounded mt-1"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Phone Number</label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        phone: e.target.value,
                      })
                    }
                    className="w-full border p-2 rounded mt-1"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-rose-600 text-white py-2 rounded-lg mt-3 hover:bg-rose-700 transition disabled:opacity-60"
                >
                  {loading ? "Submitting..." : "Submit  Query"}
                </button>
              </form>

              <button
                onClick={() => setSelectedPackage(null)}
                className="absolute top-3 right-3 text-gray-400 hover:text-black"
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PackagesPage;
